import Fondo from "../assets/fondoComent.png"

const Comentarios = () => {
    return (
        <div
            className="w-full h-screen bg-cover bg-center flex items-center justify-start"
            style={{ backgroundImage: `url(${Fondo})` }}
        >
            <div className="w-full text-white px-4 md:px-20 text-center grid grid-cols-1 gap-4 md:gap-24">
                <div>
                    <h2 className="text-4xl text-yellow-400">TU PUNTO DE VISTA,</h2>
                    <h1 className="text-4xl font-bold">ES NUESTRO PUNTO DE PARTIDA</h1>
                </div>
                <div>
                    <p>Martes 8 de Febrero , 2022</p>
                    <h2 className="text-2xl text-yellow-400 font-bold">"Un servicio increíble. Ayudó a mejorar la administración de mi empresa"</h2>
                </div>
                <div>
                    <p className="text-lg">Julio Corona Castillo</p>
                    <p className="text-lg">Gerente general, Puebla, Pue</p>
                </div>
            </div>
        </div>
    );
};

export default Comentarios;